/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TuberculosisHistoryDtoPreviousBloodTest =
  (typeof TuberculosisHistoryDtoPreviousBloodTest)[keyof typeof TuberculosisHistoryDtoPreviousBloodTest];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TuberculosisHistoryDtoPreviousBloodTest = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
